// extracted by mini-css-extract-plugin
export default {"buttonResume":"Resume_buttonResume__J1UVg"};